// extracted by mini-css-extract-plugin
export default {"list_item":"ListItem_list_item__VFUvm"};